import React from "react";
import { Col, Row } from "reactstrap";
import { joinCss } from "../helpers/utils";

import ResultsBoard from "../Search/Results/ResultsBoard";

import classes from "./Main.module.scss";

const Main = () => (
  <Row className={joinCss(classes.mainRow, "row justify-content-rigth")}>
    <Col md="1" />
    <Col md="10">
      <ResultsBoard />
    </Col>
    <Col md="1" />
  </Row>
);

export default Main;
